import styled from 'styled-components';
import { Modal } from 'opencare-crown';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import { Div } from 'common/styles/oc-styled-components';

export const MobileCloseButton = styled.button`
  appearance: none;
  padding: 0;
  background: none;
  border: none;
  position: absolute;
  top: 1px;
  right: 3px;
  cursor: pointer;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    display: none;
  }
`;

export const StyledModal = styled(Modal)`
  && {
    width: ${props => props.width || '600px'};
    max-width: 100%;

    @media screen and (max-height: ${BREAKPOINTS.desktopMin}px) {
      top: 10px;
    }

    .ant-modal-body {
      display: flex;
      flex-direction: column;

      padding: ${props => props.padding?.desktop || '30px 40px'};
    }

    .ant-modal-close {
      right: 0;
      top: 4px;

      .ant-modal-close-x {
        width: 40px;
        height: 40px;

        .anticon {
          vertical-align: 10px;
        }
      }
    }

    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      .ant-modal-close {
        display: none;
      }

      .ant-modal-body {
        background-color: ${colors.white};
        bottom: 0;
        left: 0;
        overflow-y: scroll;
        padding: ${props => props.padding?.mobile || '25px 20px'};
        position: fixed;
        right: 0;
        top: 0;
        width: 100%;
      }
    }
  }
`;

export const OpencareModalHeader = styled(Div)`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  font-size: 24px;
  color: ${colors.navy};
  font-weight: bold;
`;

export const OpencareModalBody = styled(Div)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
`;

export const OpencareModalFooter = styled(Div)`
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row-reverse'};
`;
